import components from './components';
import providers from './providers';
import templates from './templates';
import wizard from './Wizard';
export default {
    components: components,
    providers: providers,
    templates: templates,
    displays: {
        wizard: wizard
    },
};
